export const translations = {
	'Chart': {
		"no": "Diagram"
	},
	'Information': {
		"no": "Informasjon"
	},
	'Ignore missing data': {
		"no": "Ignorer manglende data"
	},
	'Hide errors': {
		no: "Skjul feil"
	},
	'Show trend': {
		no: "Vis trend"
	},
	'Show threshold': {
		no: "Vis terskelverdi"
	},
	'Aggregation': {
		no: "Aggregering"
	},
	'Chart type': {
		no: "Diagramtype"
	},
	'Y-Axis Max': {
		no: "Y-akse maks"
	},
	'Y-Axis Min': {
		no: "Y-akse min"
	},
	'Close': {
		no: "Lukk"
	},
	'Cancel': {
		no: "Avbryt"
	},
	'Update': {
		no: "Oppdater"
	},
	'Legend': {
		no: 'Diagramforklaring'
	},
	'Tooltip': {
		no: 'Muspekertips'
	},
	'Static': {
		no: 'Statisk'
	},
	'Dynamic': {
		no: 'Dynamisk'
	},
	'High': {
		no: 'Høy'
	},
	'Low': {
		no: 'Lav'
	},
	'Average': {
		no: 'Gjennomsnitt'
	},
	'Line': {
		no: 'Linje'
	},
	'Area': {
		no: 'Area'
	},
	'Range': {
		no: 'Range'
	},
	'MAX_LABEL': {
		en: 'Y-Axis Maximum (Value): Choose how the maximum value of the Y-axis is set.\nDynamic (default): Max value in Axis automatically adjusts based on data. \nStatic: User enters a fixed value. Graph will not be shown above this value',
		no: 'Y-akse maksimum (verdi): Velg hvordan maksimalverdien for Y-aksen skal angis.\nDynamisk (standard): Maksverdien på aksen justeres automatisk basert på dataene.\nStatisk: Angi en fast verdi. Grafen vil ikke vises over denne verdien.'
	},
	'MIN_LABEL': {
		en: 'Y-Axis Minimum (Value): Choose how the minimum value of the Y-axis is set.\nDynamic : Min value in Axis automatically adjusts based on data. \nStatic (default): User enters a fixed value. This will be base of the graph. Default is 0.',
		no: 'Y-akse minimum (verdi): Velg hvordan minimumsverdien for Y-aksen skal angis.\nDynamisk: Minimumsverdien på aksen justeres automatisk basert på dataene.\nStatisk (standard): Angi en fast verdi. Dette er bunnnivå til grafen. Standard er 0.'
	},
	'AGGREGATION_LABEL': {
		en: 'Aggregation: A data point in the chart can consist of multiple metrics depending on the timescale. By default we show the highest values',
		no: 'Aggregering: Et datapunkt kan best\u00E5 av flere metrikker avhengig av tidsskala. Som standard viser vi høyeste verdi av disse beregningene'
	},
	'Settings are temporary and apply only in this session.': {
		no: 'Innstillingene er midlertidige og gjelder kun for denne økten.'
	},
	'Changes are persisted': {
		no: 'Endringer beholdes'
	}
};
